import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    InputLabel,
    FormControlLabel,
    Radio,
    RadioGroup,
    Divider, Checkbox, ButtonGroup, Table, TableHead, TableRow, TableCell, TableBody, CardHeader,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {CheckBox, RemoveRedEye, Web} from "@mui/icons-material";
import PrintIcon from "@mui/icons-material/Print";
import {
    useDebtorStudentsWebReportMutation,
    useLazyPracticeDebtorStudentsWebReportQuery
} from "../store/reports/reportsApi";
import copyObject from "../utils/copyObject";
import {useGetFacultiesQuery} from "../store/faculty/facultyApi";

export default function PracticeDebtorStudentsReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [webDataRequest, setWebDataRequest] = useState({
        byDate: new Date(),
        filterType: 1,
        daysAfterSession: null,
        presentationType: 0,
        educationalForm: 0,
        includeNotClosedStatements: false
    });
    const [copyOfData, setCopyOfData] = useState(null);
    const [dataRequest] = useLazyPracticeDebtorStudentsWebReportQuery();
    const {data: facultiesData} = useGetFacultiesQuery();
    const [presentationType, setPresentationType] = useState(0);
    const [copyOfFacultiesData, setCopyOfFacultiesData] = useState(null);
    const [selectedFacultyId, setSelectedFacultyId] = useState(null);
    let reportType = 'by-date';
    let byDate = null;
    let daysAfterSession = null;

    useEffect(() => {
        if (facultiesData) {
            setCopyOfFacultiesData(copyObject(facultiesData));
        }
    }, [facultiesData])

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date) {
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    function onReportTypeChanged(value) {
        reportType = value;

        webDataRequest.filterType = reportType === 'by-date' ? 1 : 2;
    }

    async function getPrintableReport() {
        setIsLoading(true);

        try {
            const response = await fetch(`/Reports/PracticeDebtorStudentsPrintableReport?byDate=${webDataRequest.byDate}&facultyId=${selectedFacultyId ?? 0}&educationalForm=${webDataRequest.educationalForm}&presentationType=${webDataRequest.presentationType}&includeNotClosedStatements=${webDataRequest.includeNotClosedStatements}&fileType=xlsx`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    "semesterid": localStorage.getItem("selectedSemesterId")
                }
            });

            if (!response.ok) {
                throw new Error(`Не удалось сформировать отчет: HTTP ${response.status}`);
            }

            const file = await response.blob();
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Задолжники по практике на ${formatDate(new Date(webDataRequest.byDate))}.xlsx`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
            alert('Не удалось сформировать отчет. Повторите попытку позднее.');
        } finally {
            setIsLoading(false);
        }
    }

    async function loadData() {
        setIsLoading(true);
        await dataRequest({data: webDataRequest}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setCopyOfData(copyObject(fulfilled.faculties));
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsLoading(false);
        });
    }

    function daysAfterSessionChanged(value) {
        daysAfterSession = parseInt(value, 10);
        onReportTypeChanged('days-after-session');
        webDataRequest.daysAfterSession = daysAfterSession;
    }

    function byDateChanged(value) {
        byDate = value;
        webDataRequest.byDate = value;
    }

    function getCurrentDate() {
        const date = new Date();
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    function getDebtorsPercentage(group) {
        return (group.debtorStudents.length * 100 / group.numberOfStudentsInGroup).toFixed(1)
    }

    function getAveragePercentage(groups) {
        let sumOfDebtors = 0;
        groups.forEach((item) => {
            sumOfDebtors += item.debtorStudents.length;
        });

        let totalNumberOfStudents = 0;
        groups.forEach((item) => {
            totalNumberOfStudents += item.numberOfStudentsInGroup;
        });

        if (totalNumberOfStudents === 0) {
            console.log(`no students`)
        }

        return (sumOfDebtors * 100 / totalNumberOfStudents).toFixed(1)
    }

    function sum(arr) {
        let temp = 0;
        arr.forEach((item) => {
            temp += item
        });

        return temp;
    }

    function numberOfDebtorsOfFaculty(faculty) {
        let totalNumberOfDebtors = 0;
        faculty.courses.forEach((course) => {
            totalNumberOfDebtors += sum(course.groups.map((group) => group.debtorStudents.length))
        });

        return totalNumberOfDebtors;
    }

    function numberOfDebtorsOfAllFaculties() {
        let totalNumberOfDebtors = 0;
        copyOfData?.forEach((faculty) => {
            faculty.courses.forEach((course) => {
                totalNumberOfDebtors += sum(course.groups.map((group) => group.debtorStudents.length))
            });
        });

        return totalNumberOfDebtors;
    }

    function percentageOfDebtorsOfFaculty(faculty) {
        const groups = [];
        faculty.courses.forEach((course) => {
            course.groups.forEach((group) => {
                groups.push(group);
            })
        });

        return getAveragePercentage(groups);
    }

    function percentageOfDebtorsOfAllFaculties() {
        const groups = [];
        copyOfData?.forEach((faculty) => {
            faculty.courses.forEach((course) => {
                course.groups.forEach((group) => {
                    groups.push(group);
                })
            });
        });

        return getAveragePercentage(groups);
    }

    function numberOfDebtorsOfFacultyWithFilters(faculty, groupType, courseNumber) {
        let numberOfDebtors = 0;
        faculty.courses.filter((course) => course.courseName.startsWith(courseNumber.toString()))
            .forEach((course) => {
                course.groups.filter((group) => group.groupType.toLowerCase() === groupType.toLowerCase())
                    .forEach((group) => {
                        numberOfDebtors += group.debtorStudents.length;
                    });
            });

        return numberOfDebtors;
    }

    function totalNumberOfDebtorsOfCourse(course) {
        let temp = 0;
        course.groups.forEach((item) => {
            temp += item.debtorStudents.length;
        });

        return temp;
    }
    
    function debtorGroupsOfFaculty(faculty) {
        const groups = [];
        faculty?.rows?.forEach((item) => {
            // проверяем наличие группы в списке
            const existingGroup = groups.find(g => g.groupName === item.groupName);
            if (existingGroup !== undefined) {
                // если студента еще нет в списке задолжников по группе
                if (existingGroup.debtorStudents.find((student) => student.studentId === item.studentId) === undefined) {
                    existingGroup.debtorStudents.push(item.studentId);
                }
            } else {
                groups.push({
                    groupName: item.groupName,
                    numberOfStudentsInGroup: item.numberOfStudentsInGroup,
                    debtorStudents: [item.studentId]
                });
            }
        });
        
        return groups;
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Студенты-задолжники по практикам`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Студенты-задолжники по практикам
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={1}>
                                <RadioGroup defaultValue="by-date"
                                            onChange={(event) => onReportTypeChanged(event.target.value)}>
                                    <Stack spacing={1}>
                                        <Stack spacing={1} direction={'row'}>
                                            <Paper elevation={0} fullWidth>
                                                <Typography fontSize={'small'} fontWeight={'bold'} alignSelf={'center'}>Сбор статистики на указанную дату</Typography>

                                                <TextField type={'date'}
                                                           defaultValue={getCurrentDate()}
                                                           onChange={(event) => {
                                                               byDateChanged(event.target.value)
                                                           }}
                                                           placeholder={'Дата экзаменов'}
                                                           size={'small'}/>
                                            </Paper>
                                        </Stack>
                                        
                                        <TextField label={'Факультет'}
                                                   size={'small'}
                                                   fullWidth
                                                   value={selectedFacultyId}
                                                   onChange={(event) => { setSelectedFacultyId(event.target.value); webDataRequest.facultyId = parseInt(event.target.value,10) }}
                                                   select>
                                            <MenuItem value={0}>Все факультеты</MenuItem>
                                            {
                                                copyOfFacultiesData?.data?.map((faculty) => {
                                                    return <MenuItem key={faculty.value}
                                                                     value={faculty.key}>{faculty.value}</MenuItem>
                                                })
                                            }
                                        </TextField>

                                        <Divider/>

                                        <Stack direction={'row'} spacing={3}>
                                            <Stack>
                                                <Typography><strong>Тип представления</strong></Typography>
                                                <Select size={'small'} defaultValue={0} onChange={(event) => {
                                                    webDataRequest.presentationType = event.target.value;
                                                    setPresentationType(event.target.value)
                                                }}>
                                                    <MenuItem value={0}>Количество студентов</MenuItem>
                                                    <MenuItem value={1}>ФИО студентов</MenuItem>
                                                </Select>
                                            </Stack>

                                            <Stack>
                                                <Typography><strong>Форма обучения</strong></Typography>
                                                <Select size={'small'} defaultValue={0} onChange={(event) => {
                                                    webDataRequest.educationalForm = event.target.value
                                                }}>
                                                    <MenuItem value={0}>Все</MenuItem>
                                                    <MenuItem value={1}>Заочная</MenuItem>
                                                    <MenuItem value={2}>Очная</MenuItem>
                                                    <MenuItem value={3}>Очно-Заочная</MenuItem>
                                                </Select>
                                            </Stack>

                                            <FormControlLabel control={<Checkbox/>}
                                                              onChange={(event, checked) => {
                                                                  webDataRequest.includeNotClosedStatements = checked
                                                              }}
                                                              label={`Учитывать открытые ведомости`}/>
                                        </Stack>



                                        <ButtonGroup orientation={'vertical'}
                                                     disabled={isLoading}>
                                            <Button variant={'contained'}
                                                    onClick={() => {
                                                        loadData()
                                                    }}
                                                    startIcon={isLoading ? <CircularProgress size={15}/> :
                                                        <RemoveRedEye/>}
                                                    size={'small'}>Просмотр</Button>
                                            <Button variant={'outlined'}
                                                    onClick={() => {
                                                        getPrintableReport()
                                                    }}
                                                    startIcon={isLoading ? <CircularProgress size={15}/> :
                                                        <PrintIcon/>}
                                                    size={'small'}>Печать XLSX</Button>
                                        </ButtonGroup>

                                        {isLoading
                                            ? <><Divider/>

                                                <Typography align={'center'} color={'gray'}>Сбор статистики может занять
                                                    некоторое время</Typography></>
                                            : <></>}
                                    </Stack>
                                </RadioGroup>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Divider/>

                    {copyOfData !== null && copyOfData !== undefined && copyOfData.length > 0
                        ? presentationType === 0
                            ? <><Typography variant={'h5'}>Подробная статистика</Typography>

                                {copyOfData?.sort((l, r) => l.facultyName > r.facultyName ? 1 : -1).map((item) => {
                                    return <Card>
                                        <CardContent>
                                            <Typography variant={'h6'}>Факультет {item.facultyName}</Typography>
                                        </CardContent>
                                        <Table size={'small'}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align={'center'}>Группа</TableCell>
                                                    <TableCell align={'center'}>Кол-во задолжников</TableCell>
                                                    <TableCell align={'center'}>Процент задолжников (относительно общего кол-ва студентов группы)</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {debtorGroupsOfFaculty(item)?.sort((l,r) => l.groupName > r.groupName ? 1 : -1).map((row) => {
                                                    return <TableRow>
                                                        <TableCell align={'center'}>{row.groupName}</TableCell>
                                                        <TableCell align={'center'}>{row.debtorStudents.length}</TableCell>
                                                        <TableCell align={'center'}>{row.numberOfStudentsInGroup === 0 ? '-' : (row.debtorStudents.length * 100 / row.numberOfStudentsInGroup).toFixed(2)}%</TableCell>
                                                    </TableRow>
                                                    })}
                                                <TableRow style={{'background-color': 'lightgray'}}>
                                                    <TableCell colSpan={2}><strong>ИТОГО</strong></TableCell>
                                                    <TableCell><strong>Относительно всех студентов университета: {item.percentageOverTheUniversity.toFixed(2)}%</strong></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </Card>
                                })}
                            </>
                            : <>
                                {copyOfData?.sort((l, r) => l.facultyName > r.facultyName ? 1 : -1).map((item) => {
                                    return <Card>
                                        <CardContent>
                                            <Typography variant={'h6'}>Факультет {item.facultyName}</Typography>
                                        </CardContent>
                                        <Table size={'small'}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align={'center'}>Группа</TableCell>
                                                    <TableCell align={'center'}>Студент</TableCell>
                                                    <TableCell align={'center'}>Ведомость</TableCell>
                                                    <TableCell align={'center'}>Статус</TableCell>
                                                    <TableCell align={'center'}>Период проведения</TableCell>
                                                    <TableCell align={'center'}>Задолженности</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item.rows?.sort((l, r) => l.fullName > r.fullName ? 1 : -1).map((student) => {
                                                    return <>
                                                        <TableRow>
                                                            <TableCell align={'center'}>{student.groupName}</TableCell>
                                                            <TableCell align={'center'}>{student.fullName}</TableCell>
                                                            <TableCell align={'center'}>{student.statementId ? (
                                                                <a href={`/practice-statement-results/${student.statementId}`} target="_blank" rel="noopener noreferrer">ℹ️</a>
                                                            ) : (
                                                                '—'
                                                            )}</TableCell>
                                                            <TableCell align={'center'}>{student.isOpen ? 'Открыта' : 'Закрыта' }</TableCell>
                                                            <TableCell align={'center'}>{toDateString(student.from)} - {toDateString(student.to)}</TableCell>
                                                            <TableCell align={'center'}>{student.debts.map((debt) => {
                                                                return <Typography fontSize={'small'}>{debt}</Typography>
                                                            })}</TableCell>
                                                        </TableRow>
                                                    </>
                                                })}
                                            </TableBody>
                                        </Table>
                                    </Card>
                                })}
                            </>
                        : <Typography fontSize={'large'}
                                      align={'center'}>{copyOfData === null ? 'Выберите необходимые фильтры, после чего нажмите на кнопку "Просмотр"' : 'Нет данных по выбранным фильтрам'}</Typography>}


                    <br/>
                </Stack>
            </Container>
        </GeneralLayout>
    )
        ;
}
